import { FactoryProvider } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { CONSENT_MANAGEMENT_TRANSLATIONS, ConsentManagementTranslations } from '@hdms/shared/util-core';

export const CONSENT_MANAGEMENT_TRANSLATION_PROVIDER: FactoryProvider = {
  provide: CONSENT_MANAGEMENT_TRANSLATIONS,
  deps: [I18NEXT_SERVICE],
  useFactory: (i18NextService: ITranslationService): ConsentManagementTranslations => ({
    privacyPolicyUrl: i18NextService.t('common.urls.didomiPrivacyPolicy')
  })
};
